import { render, staticRenderFns } from "./ClosedAccounting.vue?vue&type=template&id=7b201ffc&"
import script from "./ClosedAccounting.vue?vue&type=script&lang=js&"
export * from "./ClosedAccounting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports